import { createVanIconComponent } from "./van"

const Scan = createVanIconComponent("scan")
export default Scan
